import { TextField, Toolbar, Typography } from '@mui/material';
import { getDetailSearchListToolBarApi } from 'api/meeting';
import { useState } from 'react';
function DetailSearchDataTableToolbar({ pageTitle, setData, setLoading, type, setSearchType, setToolbarPayload }) {
    const [searchText, setSearchText] = useState("");


    const handleKeyDown = async (event) => {
        // if (event.key === 'Enter') {
        //     try {
        //         setLoading(true);

        //         const res = await getDecisionStatusListToolBarApi({ searchText, pageType: "detail" });
        //         setData(res.data);
        //         const payload = {
        //             searchText: searchText,
        //             pageType: "detail"
        //         };
        //         setToolbarPayload(payload);
        //         setSearchType("toolbar");
        //         setLoading(false);
        //     } catch (error) {
        //         console.error("Arama sırasında hata oluştu:", error);
        //     }
        // }


        if (event.key === 'Enter') {
            try {
                setLoading(true);
                const res = await getDetailSearchListToolBarApi({ searchText });
                // const data = getFilteredResult(res.data); // yetkili olunan birimleri getirir
                setData(res.data);
                const payload = {
                    searchText: searchText
                };
                setToolbarPayload(payload);
                setSearchType("toolbar");
                setLoading(false);
            } catch (error) {
                console.error("Arama sırasında hata oluştu:", error);
            }
        }
    };


    return (
        <Toolbar className="table-header row" sx={{ justifyContent: 'space-between', gap: 2 }}>
            <Typography variant="h6" component="h1">{pageTitle}</Typography>
            <TextField
                id="searchText1xe"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={handleKeyDown}
                margin="dense"
                label="Arama Yap"
                className="mr-4"
                sx={{ flexGrow: 1, background: 'white' }}
                placeholder="Bilgi"
            />

        </Toolbar>
    );

}

export default DetailSearchDataTableToolbar;
